import React from 'react';

import {
  Actions as ActionsUI,
  Action,
  EditIcon,
  LockIcon,
  LockOpenIcon,
  FileCopyIcon,
} from '@gogame/components';

const Actions = ({ onEdit, onDuplicate, onBlock, onUnBlock, isActive }) => {
  return (
    <ActionsUI limit={3}>
      <Action
        id={'duplicate'}
        icon={<FileCopyIcon />}
        label={'Duplicate'}
        onClick={onDuplicate}
      />
      <Action id={'edit'} icon={<EditIcon />} label={'Edit'} onClick={onEdit} />
      {isActive ? (
        <Action
          id={'block'}
          icon={<LockIcon />}
          label={'Block user'}
          onClick={onBlock}
        />
      ) : (
        <Action
          id={'unblock'}
          icon={<LockOpenIcon />}
          label={'Unblock user'}
          onClick={onUnBlock}
        />
      )}
    </ActionsUI>
  );
};

export default Actions;
